/*
 * 세금계산서 관리 — 표시 라벨·금액·CSV.
 * 엑셀은 BO 에 xlsx 라이브러리가 없어 CSV(UTF-8 BOM, 엑셀에서 바로 열림)로 만든다. 다른 엑셀 다운로드는 서버 생성이다.
 */

export const KEYWORD_TYPES = ['ALL', 'COMPANY', 'CEO', 'REQUESTER', 'ORDER_NO'] as const;
export const TAX_TYPES = ['ALL', 'TAXABLE', 'FREE'] as const;

/** 주문상태 필터 — order domain OrderStatus(BE orderStatuses 파라미터). 라벨은 orders.orderStatus.* */
export const ORDER_STATUS_FILTER = [
  'PENDING_PAYMENT',
  'PAYMENT_CONFIRMED',
  'READY_FOR_FULFILLMENT',
  'FULFILLING',
  'FULFILLED',
  'COMPLETED',
  'CANCEL_REQUESTED',
  'PARTIALLY_CANCELED',
  'CANCELED',
] as const;

export const won = (amount: number): string => `₩${amount.toLocaleString('ko-KR')}`;

const KST_DATE_TIME = new Intl.DateTimeFormat('ko-KR', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
export const formatDateTime = (iso: string | null): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '-' : KST_DATE_TIME.format(d);
};

/** 오늘(KST) yyyy-MM-dd. */
export const todayKst = (): string =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());

/** n 일 전(KST) yyyy-MM-dd. */
export const daysAgoKst = (days: number): string =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit' }).format(
    new Date(Date.now() - days * 24 * 60 * 60 * 1000),
  );

/** 사업자번호 표시 000-00-00000 (10자리일 때만). */
export const formatBusinessNo = (raw: string): string => {
  const d = raw.replace(/\D/g, '');
  return d.length === 10 ? `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}` : raw;
};

const csvCell = (v: unknown): string => {
  const text = v == null ? '' : String(v);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** 헤더 + 행 → CSV 문자열(UTF-8 BOM, CRLF). */
export const toCsv = (header: ReadonlyArray<string>, rows: ReadonlyArray<ReadonlyArray<unknown>>): string =>
  `﻿${[header, ...rows].map((r) => r.map(csvCell).join(',')).join('\r\n')}\r\n`;

export const downloadCsv = (filename: string, csv: string): void => {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
